var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82513 8.32215L1.57665 0.462937C1.43902 0.331736 1.25617 0.258545 1.06602 0.258545C0.875875 0.258545 0.693025 0.331736 0.555395 0.462937L0.546514 0.471817C0.479562 0.535421 0.42625 0.61198 0.38982 0.696838C0.35339 0.781695 0.334603 0.873077 0.334603 0.965423C0.334603 1.05777 0.35339 1.14915 0.38982 1.23401C0.42625 1.31887 0.479562 1.39543 0.546514 1.45903L8.31397 8.85942L0.546514 16.2569C0.479562 16.3205 0.42625 16.397 0.38982 16.4819C0.35339 16.5667 0.334603 16.6581 0.334603 16.7505C0.334603 16.8428 0.35339 16.9342 0.38982 17.019C0.42625 17.1039 0.479562 17.1805 0.546514 17.2441L0.555395 17.2529C0.693025 17.3841 0.875875 17.4573 1.06602 17.4573C1.25617 17.4573 1.43902 17.3841 1.57665 17.2529L9.82513 9.39373C9.89767 9.32462 9.95542 9.24149 9.99488 9.14939C10.0343 9.05729 10.0547 8.95814 10.0547 8.85794C10.0547 8.75774 10.0343 8.65859 9.99488 8.56649C9.95542 8.47439 9.89767 8.39127 9.82513 8.32215Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationForwardIcon);
export default __webpack_public_path__ + "static/media/PaginationForwardIcon.565f2820fa0f798e63323b98e516aa50.svg";
export { ForwardRef as ReactComponent };